import { Helmet } from 'react-helmet-async';

import ProfileDocumentsContainer from 'src/sections/profile-documents/profile-documents-container';

// ----------------------------------------------------------------------

export default function CandidateProfileDocumentsPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: My Documents</title>
      </Helmet>

      <ProfileDocumentsContainer />
    </>
  );
}
